import { type BaseDto } from "@pasta/box-v2";
import { type LetterFileSearchDto } from "./letter-file.dto";

export enum ExportStatus {
  TODO = "TODO",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export interface LetterFileExportDto extends BaseDto {
  /** the exported file, once completed */
  fileId?: number;
  hits: number;
  status: ExportStatus;
  searchQuery: LetterFileSearchDto;
}
